import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.promise.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getReq, postReq } from './axios';
var BASE_URL = "".concat(apiUrl, "/payment");
export var getAllPayments = function getAllPayments(params) {
  return getReq("".concat(BASE_URL), {
    params: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (params === null || params === void 0 ? void 0 : params.pageSize) && {
      per_page: params === null || params === void 0 ? void 0 : params.pageSize
    }), (params === null || params === void 0 ? void 0 : params.pageIndex) !== undefined && {
      page: (params === null || params === void 0 ? void 0 : params.pageIndex) + 1
    }), (params === null || params === void 0 ? void 0 : params.office) && {
      office_id: params === null || params === void 0 ? void 0 : params.office
    }), (params === null || params === void 0 ? void 0 : params.employee) && {
      employee_id: params === null || params === void 0 ? void 0 : params.employee
    }), (params === null || params === void 0 ? void 0 : params.franchisee) && {
      franchisee_id: params === null || params === void 0 ? void 0 : params.franchisee
    }), (params === null || params === void 0 ? void 0 : params.partner) && {
      partner_id: params === null || params === void 0 ? void 0 : params.partner
    }), (params === null || params === void 0 ? void 0 : params.creditNumber) && {
      credit_number: params === null || params === void 0 ? void 0 : params.creditNumber
    }), (params === null || params === void 0 ? void 0 : params.collectionStatus) && {
      collection_status: params === null || params === void 0 ? void 0 : params.collectionStatus
    }), (params === null || params === void 0 ? void 0 : params.startDate) && {
      date_from: params === null || params === void 0 ? void 0 : params.startDate
    }), (params === null || params === void 0 ? void 0 : params.endDate) && {
      date_to: params === null || params === void 0 ? void 0 : params.endDate
    }), (params === null || params === void 0 ? void 0 : params.sortBy) && {
      sort_by: params === null || params === void 0 ? void 0 : params.sortBy
    }), (params === null || params === void 0 ? void 0 : params.direction) && {
      direction: params === null || params === void 0 ? void 0 : params.direction
    })
  });
};
export var reportPayments = function reportPayments(paymentIds) {
  return postReq("".concat(BASE_URL, "/report"), {
    payment_ids: paymentIds
  });
};
export var getDocumentForPayment = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id, documentId) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", getReq("".concat(BASE_URL, "/").concat(id, "/getDocumentForPayment/").concat(documentId), {
              responseType: 'arraybuffer'
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getDocumentForPayment(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var signDocumentForPayment = function signDocumentForPayment(paymentId, documentId, body) {
  return postReq("".concat(BASE_URL, "/").concat(paymentId, "/signDocumentForPayment/").concat(documentId), body, {
    responseType: 'arraybuffer'
  });
};
export var getReportedPayments = function getReportedPayments(params) {
  return getReq("".concat(BASE_URL, "/report"), {
    params: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (params === null || params === void 0 ? void 0 : params.pageSize) && {
      per_page: params === null || params === void 0 ? void 0 : params.pageSize
    }), (params === null || params === void 0 ? void 0 : params.pageIndex) !== undefined && {
      page: (params === null || params === void 0 ? void 0 : params.pageIndex) + 1
    }), (params === null || params === void 0 ? void 0 : params.office) && {
      office_id: params === null || params === void 0 ? void 0 : params.office
    }), (params === null || params === void 0 ? void 0 : params.employee) && {
      employee_id: params === null || params === void 0 ? void 0 : params.employee
    })
  });
};
export var confirmReport = function confirmReport(reportId) {
  return postReq("".concat(BASE_URL, "/report/").concat(reportId, "/confirm"), {});
};
export var getReportDocument = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(reportId, documentType) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", getReq("".concat(BASE_URL, "/report/").concat(reportId, "/document/").concat(documentType), {
              responseType: 'arraybuffer'
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getReportDocument(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();